import React, { useState, useEffect } from 'react'
import classnames from 'classnames'
import CdnImage from '@/components/app/cdn-image'
import styles from './coverart.module.scss'

interface Props {
  src?: string
  alt?: string
}

const Coverart = ({ src, alt = '' }: Props) => {
  const [ isActive, setActive ] = useState(false)
  useEffect(() => setActive(true), [ src ])

  return (
    <figure className={classnames(styles.coverart, 'shadow-lg', { [styles.active]: isActive })}>
      <CdnImage
        src={src}
        alt={alt}
        width={600}
        height={600}
      />
    </figure>
  )
}

export default Coverart
